import { checkEmailAvailability } from "../../global/Firebase/firebase"
import { CURRENCIES } from "../../utils/currencies"
import { PRIMARY_GOALS, BUSINESS_TYPES, CLIENT_TYPES, ADDITIONAL_FEATURES, PRIOR_EXPERIENCE, SETUP_OPTIONS, TRAFFIC_SOURCE } from "../../utils/organizationTypes"

export default [
  // {
  //   id: 'primaryGoalScreen',
  //   content: [
  //     { 
  //       id: 'title',
  //       type: 'title',
  //       props: {
  //         text: 'funnel.chooseYourPrimaryGoal'
  //       }
  //     },
  //     { 
  //       id: 'primaryGoal',
  //       type: 'singleSelect',
  //       props: {
  //         options: PRIMARY_GOALS,
  //         localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.' + item.id)}))}
  //       }
  //     },
  //   ]
  // },
  {
    id: 'businessTypeScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.chooseYourBusinessType'
        }
      },
      { 
        id: 'businessType',
        type: 'singleSelect',
        props: {
          options: BUSINESS_TYPES,
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.' + item.id)}))}
        }
      },
    ]
  },
  {
    id: 'choseAtlasScreen',
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.choseAtlas',
          subtitle: 'funnel.choseAtlasDescription',
          centered: true
        }
      },
      {
        id: 'image',
        type: 'image',
        props: {
          source: require('../../assets/funnel/undraw_grades.png')
        }
      }, 
      {
        id: 'button',
        type: 'button',
        props: {
          text: 'continue',
        }
      }
    ]
  },
  {
    id: 'clientTypeScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.chooseYourClientType'
        }
      },
      { 
        id: 'clientType',
        type: 'singleSelect',
        props: {
          options: CLIENT_TYPES,
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.' + item.id)}))}
        }
      },
    ]
  },
  {
    id: 'monthlySalesScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.monthlySalesVolume'
        }
      },
      { 
        id: 'monthlySales',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'less1k' },
            { id: 'from1kTo10k' },
            { id: 'from10kTo20k' },
            { id: 'from20kTo50k' },
            { id: 'more50k' }
          ],
          localization: (options, t) => {
            return options.map(item => ({
              ...item, 
              text: t('funnel.salesVolume' + item.id.charAt(0).toUpperCase() + item.id.slice(1))
            }))
          }
        }
      },
    ]
  },
  {
    id: 'inventorySizeScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.inventorySize'
        }
      },
      { 
        id: 'inventorySize',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'less50' },
            { id: '50to200' },
            { id: '200to1000' },
            { id: 'more1000' }
          ],
          localization: (options, t) => {
            return options.map(item => ({
              ...item, 
              text: t('funnel.inventory' + item.id.charAt(0).toUpperCase() + item.id.slice(1))
            }))
          }
        }
      },
    ]
  },
  {
    id: 'currencyScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.chooseYourCurrency'
        }
      },
      { 
        id: 'currency',
        type: 'singleSelect',
        props: {
          options: CURRENCIES,
          withSearch: true,
          localization: (options, t) => {return options.map(item => ({...item, text: item.shortText + ' - ' + t('currencies.' + item.id)}))}
        }
      },
    ]
  },
  {
    id: 'branchScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.doYouHaveBranches'
        }
      },
      { 
        id: 'hasBranches',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'yes' },
            { id: 'no' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.' + item.id)}))}
        }
      },
    ]
  },
  {
    id: 'branchCountScreen',
    condition: (answers) => {
      return answers.hasBranches?.id === 'yes'
    },
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.branchCount'
        }
      },
      { 
        id: 'branchCount',
        type: 'numberField',
        props: {
          validationRules: {
            min: 1,
            max: 100
          }
        }
      },
    ]
  },
  {
    id: 'employeeCountScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.employeeCount'
        }
      },
      { 
        id: 'employeeCount',
        type: 'singleSelect',
        props: {
          options: [
            { id: '0' },
            { id: '1-5' },
            { id: '5-20' },
            { id: '20-50' },
            { id: '50+' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.' + item.id)}))}
        }
      },
    ]
  },
  {
    id: 'priorExperienceScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.yourPriorExeperience'
        }
      },
      { 
        id: 'priorExperience',
        type: 'singleSelect',
        props: {
          options: PRIOR_EXPERIENCE,
          localization: (options, t) => {return options.map(item => ({...item, text: t('login.priorExperience' + item.id.charAt(0).toUpperCase() + item.id.slice(1))}))}
        }
      },
    ]
  },
  {
    id: 'profitabilityScreen',
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.profitabilityTitle',
          subtitle: 'funnel.profitabilityDescription',
          centered: true
        }
      },
      {
        id: 'image',
        type: 'image',
        props: {
          source: require('../../assets/funnel/undraw_stepping_up.png')
        }
      },
      {
        id: 'button',
        type: 'button',
        props: {
          text: 'continue'
        }
      }
    ]
  },
  {
    id: 'salesReportsScreen',
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.salesReportsTitle',
          subtitle: 'funnel.salesReportsDescription',
        }
      },
      { 
        id: 'salesReports',
        type: 'multiSelect',
        props: {
          options: [
            { id: 'overall' },
            { id: 'byProduct' },
            { id: 'byEmployee' },
            { id: 'withProfit' },
            { id: 'spendings' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.salesReports' + item.id.charAt(0).toUpperCase() + item.id.slice(1))}))}
        }
      },
    ]
  },
  {
    id: 'inventoryTrackingScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.inventoryTrackingQuestion'
        }
      },
      { 
        id: 'inventoryTrackingNeeds',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'none' },
            { id: 'basic' },
            { id: 'advanced' },
          ],
          localization: (options, t) => {
            return options.map(item => ({
              ...item, 
              text: t('funnel.inventoryTracking' + item.id.charAt(0).toUpperCase() + item.id.slice(1))
            }))
          }
        }
      },
    ]
  },
  {
    id: 'inventoryOperationsScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.inventoryOperationsQuestion'
        }
      },
      { 
        id: 'inventoryOperationNeeds',
        type: 'multiSelect',
        props: {
          options: [
            { id: 'supplies' },
            { id: 'writeOffs' },
            { id: 'transfers' },
            { id: 'revisions' },
            { id: 'manufacture' }
          ],
          localization: (options, t) => {
            return options.map(item => ({
              ...item, 
              text: t('funnel.inventoryOperations' + item.id.charAt(0).toUpperCase() + item.id.slice(1))
            }))
          }
        }
      },
    ]
  },
  {
    id: 'barcodeNeedsScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.barcodeQuestion'
        }
      },
      { 
        id: 'barcodeNeeds',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'no' },
            { id: 'yesOwn' },
            { id: 'yesSupplier' },
            { id: 'wantToStart' }
          ],
          localization: (options, t) => {
            return options.map(item => ({
              ...item, 
              text: t('funnel.barcode' + item.id.charAt(0).toUpperCase() + item.id.slice(1))
            }))
          }
        }
      }
    ]
  },
  {
    id: 'clientTrackingScreen',
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.clientTrackingTitle',
          subtitle: 'funnel.clientTrackingDescription',
        }
      },
      { 
        id: 'wantClientTracking',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'yes' },
            { id: 'no' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.' + item.id)}))}
        }
      },
    ]
  },
  {
    id: 'loyaltyProgramScreen',
    condition: (answers) => {
      return answers.wantClientTracking?.id === 'yes'
    },
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.loyaltyProgramTitle',
          subtitle: 'funnel.loyaltyProgramDescription',
        }
      },
      { 
        id: 'loyaltyType',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'none' },
            { id: 'cashback' },
            { id: 'punchCard' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.loyaltyType' + item.id.charAt(0).toUpperCase() + item.id.slice(1))}))}
        }
      },
    ]
  },
  {
    id: 'cashbackLevelScreen',
    condition: (answers) => {
      return answers.loyaltyType?.id === 'cashback'
    },
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.cashbackLevelTitle',
          subtitle: 'funnel.cashbackLevelDescription',
        }
      },
      { 
        id: 'defaultBonusLevel',
        type: 'singleSelect',
        props: {
          options: [
            { id: '1' },
            { id: '3' },
            { id: '5' },
            { id: '7' },
            { id: '10' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.bonusLevel', { percent: item.id })}))}
        }
      },
    ]
  },
  {
    id: 'punchCardCapacityScreen',
    condition: (answers) => {
      return answers.loyaltyType?.id === 'punchCard'
    },
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.punchCardCapacityTitle',
          subtitle: 'funnel.punchCardCapacityDescription',
        }
      },
      { 
        id: 'punchCardCapacity',
        type: 'singleSelect',
        props: {
          options: [
            { id: '5' },
            { id: '7' },
            { id: '10' },
            { id: '12' },
            { id: '15' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.punchCardCapacity', { count: item.id })}))}
        }
      },
    ]
  },
  {
    id: 'onlineCatalogScreen',
    content: [
      { 
        id: 'title',
        type: 'titleWithSubtitle',
        props: {
          title: 'funnel.onlineCatalogTitle',
          subtitle: 'funnel.onlineCatalogDescription',
        }
      },
      { 
        id: 'wantOnlineCatalog',
        type: 'singleSelect',
        props: {
          options: [
            { id: 'yes' },
            { id: 'no' },
          ],
          localization: (options, t) => {return options.map(item => ({...item, text: t('funnel.' + item.id)}))}
        }
      },
    ]
  },
  {
    id: 'additionalFeaturesScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.chooseAdditionalFeatures'
        }
      },
      { 
        id: 'additionalFeatures',
        type: 'multiSelect',
        props: {
          options: ADDITIONAL_FEATURES,
          localization: (options, t) => {return options.map(item => ({...item, text: t('login.goal' + item.id.charAt(0).toUpperCase() + item.id.slice(1))}))}
        }
      },
    ]
  },
  {
    id: 'setupOptionsScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.setupOptions'
        }
      },
      { 
        id: 'setupOption',
        type: 'singleSelect',
        props: {
          options: SETUP_OPTIONS,
          localization: (options, t) => {return options.map(item => ({...item, text: t('login.setupOption' + item.id.charAt(0).toUpperCase() + item.id.slice(1))}))}
        }
      },
    ]
  },
  {
    id: 'trafficSourceScreen',
    content: [
      { 
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.trafficSource'
        }
      },
      { 
        id: 'trafficSource',
        type: 'singleSelect',
        props: {
          options: TRAFFIC_SOURCE,
          localization: (options, t) => {return options.map(item => ({...item, text: t('login.trafficSource' + item.id.charAt(0).toUpperCase() + item.id.slice(1))}))}
        }
      },
    ]
  },
  {
    id: 'analysisScreen',
    content: [
      {
        id: 'loader',
        type: 'loader',
        props: {
          duration: 10000, // 10 seconds
          nextScreen: 'orgNameScreen'
        }
      },
      {
        id: 'reviewsSlider',
        type: 'reviewsSlider',
        props: {
          reviews: [
            { id: '1' },
          ],
        }
      },
    ]
  },
  {
    id: 'orgNameScreen',
    content: [
      {
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.orgName'
        }
      },
      { 
        id: 'orgName',
        type: 'textField',
        props: {
          validationRules: {
            minLength: 1
          }
        }
      },
    ]
  },
  {
    id: 'userNameScreen',
    content: [
      {
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.userName'
        }
      },
      { 
        id: 'userName',
        type: 'textField',
        props: {
          validationRules: {
            minLength: 1
          }
        }
      },
    ]
  },
  {
    id: 'userPhoneScreen',
    content: [
      {
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.userPhone'
        }
      },
      { 
        id: 'phone',
        type: 'phoneField',
        props: {
          validationRules: {
            minLength: 5
          }
        }
      },
      // WA-ONBOARD-001 — the WhatsApp activation opt-in, deliberately on THIS screen: consent has
      // to name the number it applies to, and this is the only screen where the merchant can see
      // the number they are consenting for.
      //
      // ⛔ `defaultValue: false` and `required: false` are both load-bearing. A pre-ticked box is
      // not consent under Meta's policy, and inheriting FunnelScreen's default `required: true`
      // would make ticking it a condition of finishing signup — which is coercion, not consent,
      // and would break the funnel for everyone who declines.
      {
        id: 'whatsappOptIn',
        type: 'checkboxField',
        props: {
          defaultValue: false,
          label: 'login.whatsappOptIn',
          disclosure: 'login.whatsappOptInDisclosure',
          validationRules: {
            required: false
          }
        }
      },
    ]
  },
  {
    id: 'userEmailScreen',
    content: [
      {
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.userEmail'
        }
      },
      { 
        id: 'email',
        type: 'emailField',
        props: {
          validationRules: {
            pattern: {
              value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              message: 'email',
            },
            validate: async (value) => {
              const isEmailAvailable = await checkEmailAvailability(value)
              return isEmailAvailable || 'emailTaken'
            }
          }
        }
      },
    ]
  },
  {
    id: 'passwordScreen',
    content: [
      {
        id: 'title',
        type: 'title',
        props: {
          text: 'funnel.userPassword'
        }
      },
      { 
        id: 'password',
        type: 'passwordField',
        props: {
          validationRules: {
            minLength: 5
          }
        }
      },
    ]
  },
]
